import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import { NavbarComponent } from './navbar/navbar.component';
import { HomeComponent } from './home/home.component';
import { TokenComponent } from './components/token/token.component';
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SubmitbatchComponent } from './components/submitbatch/submitbatch.component';
import { WebsocketComponent } from './components/websocket/websocket.component';
import { JobdetailsComponent } from './components/jobdetails/jobdetails.component';
import { JobsettingsComponent } from './components/jobsettings/jobsettings.component';
import { FooterComponent } from './footer/footer.component';

import { AuthcustomerComponent } from './api-page/auth-api/authcustomer/authcustomer.component';
import { OciAuthComponent } from './api-page/auth-api/oci-auth/oci-auth.component';
import { S3authComponent } from './api-page/auth-api/s3auth/s3auth.component';
import { DropboxauthComponent } from './api-page/auth-api/dropboxauth/dropboxauth.component';
import { GoogledriveauthComponent } from './api-page/auth-api/googledriveauth/googledriveauth.component';

import { OCIbatchComponent } from './api-page/batch-api/ocibatch/ocibatch.component';
import { S3batchComponent } from './api-page/batch-api/s3batch/s3batch.component';
import { DropboxbatchComponent } from './api-page/batch-api/dropboxbatch/dropboxbatch.component';
import { GoogledrivebatchComponent } from './api-page/batch-api/googledrivebatch/googledrivebatch.component';

import { JoblistComponent } from './api-page/other-api/joblist/joblist.component';
import { CustomerupdateComponent } from './api-page/other-api/customerupdate/customerupdate.component';

import { ApilistComponent } from './components/apilist/apilist.component';

import { DropboxListFileComponent } from './api-page/list-api/dropbox-list-file/dropbox-list-file.component';
import { DrivelistfileComponent } from './api-page/list-api/drivelistfile/drivelistfile.component';
import { S3listfileComponent } from './api-page/list-api/s3listfile/s3listfile.component';
import { OCilistfileComponent } from './api-page/list-api/ocilistfile/ocilistfile.component';

import { CommonModule } from '@angular/common';

import { DrivedisconnectComponent } from './api-page/disconnect-api/drivedisconnect/drivedisconnect.component';
import { OcidisconnectComponent } from './api-page/disconnect-api/ocidisconnect/ocidisconnect.component';
import { DropboxdisconnectComponent } from './api-page/disconnect-api/dropboxdisconnect/dropboxdisconnect.component';
import { S3disconnectComponent } from './api-page/disconnect-api/s3disconnect/s3disconnect.component';


import { CreateS3urlComponent } from './api-page/storage-api/create-s3url/create-s3url.component';
import { MultipartuploadComponent } from './api-page/storage-api/multipartupload/multipartupload.component';
import { GenerateurlComponent } from './api-page/storage-api/generateurl/generateurl.component';
import { CompletemultipartComponent } from './api-page/storage-api/completemultipart/completemultipart.component';
import { AbortmultipartComponent } from './api-page/storage-api/abortmultipart/abortmultipart.component';




import { LocalbatchComponent } from './api-page/batch-api/localbatch/localbatch.component';
import { TokenandkeyComponent } from './components/tokenandkey/tokenandkey.component';
import { GetjobComponent } from './api-page/other-api/getjob/getjob.component';
import { WebhookComponent } from './components/webhook/webhook.component';
import { ListimagebatchComponent } from './api-page/other-api/listimagebatch/listimagebatch.component';
import { GetimagebatchComponent } from './api-page/other-api/getimagebatch/getimagebatch.component';
import { VideojobComponent } from './api-page/publicURL-api/videojob/videojob.component';
import { ImagejobComponent } from './api-page/publicURL-api/imagejob/imagejob.component';
import { NewApiListComponent } from './components/new-api-list/new-api-list.component';
import { LiveBroadcastComponent } from './components/live-broadcast/live-broadcast.component';






@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    TokenComponent,
    AuthenticationComponent,
    SubmitbatchComponent,
    WebsocketComponent,
    JobdetailsComponent,
    JobsettingsComponent,
    FooterComponent,
    AuthcustomerComponent,
    OciAuthComponent,
    S3authComponent,
    DropboxauthComponent,
    GoogledriveauthComponent,
    OCIbatchComponent,
    S3batchComponent,
    DropboxbatchComponent,
    GoogledrivebatchComponent,
    JoblistComponent,
    CustomerupdateComponent,
    ApilistComponent,
    DropboxListFileComponent,
    DrivelistfileComponent,
    S3listfileComponent,
    OCilistfileComponent,
    DrivedisconnectComponent,
    OcidisconnectComponent,
    DropboxdisconnectComponent,
    S3disconnectComponent,
    CreateS3urlComponent,
    MultipartuploadComponent,
    GenerateurlComponent,
    CompletemultipartComponent,
    AbortmultipartComponent,
    LocalbatchComponent,
    TokenandkeyComponent,
    GetjobComponent,
    WebhookComponent,
    ListimagebatchComponent,
    GetimagebatchComponent,
    VideojobComponent,
    ImagejobComponent,
    NewApiListComponent,
    LiveBroadcastComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    BrowserAnimationsModule,
    CommonModule
    ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }